import { render } from "./carruselultimo_ingles.vue?vue&type=template&id=75fb11fc&scoped=true"
import script from "./carruselultimo_ingles.vue?vue&type=script&lang=js"
export * from "./carruselultimo_ingles.vue?vue&type=script&lang=js"

import "./carruselultimo_ingles.vue?vue&type=style&index=0&id=75fb11fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fb11fc"]])

export default __exports__